import styled from 'styled-components';

const Caption2 = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #232d3a;
`;

export default Caption2;
